// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hGM_s","content":"styles_content__96gzM"};